document.addEventListener("DOMContentLoaded", () => {
  const apiUrl =
    "https://endrock.novapower.io/endrockapi/v3/app/estimatedArrival2025/index.php?id=all&store=bearbalanced";
  const dateElement = document.getElementById("orderby-receiveby-value");
  dateElement.innerHTML = "&nbsp;";

  fetch(apiUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("La respuesta de la red no fue exitosa");
      }
      return response.json();
    })
    .then((data) => {
      if (data && data.data && data.data.delivery_max_date_end_at_desc) {
        const deliveryDateString = data.data.delivery_max_date_end_at_desc;

        const dateObject = new Date(deliveryDateString);
        const options = { weekday: "short", month: "short", day: "2-digit" };
        const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
          dateObject
        );

        dateElement.textContent = `  ${formattedDate}`;
      } else {
        dateElement.textContent = "Fecha no disponible";
      }
    })
    .catch((error) => {
      console.error("Hubo un problema al obtener la fecha de entrega:", error);
      dateElement.textContent = "Error al cargar fecha";
    })
    .finally(() => {
      dateElement.classList.remove("loading-skeleton");
    });
});
